export const USER_JOURNEY_NAMES = {
  LOGIN: 'login',
  SEND_MONEY_OON: 'send-money-oon',
  TAXES_UPGRADE: 'taxes-upgrade',
} as const

export type UserJourneyName = (typeof USER_JOURNEY_NAMES)[keyof typeof USER_JOURNEY_NAMES]
